import styled from 'styled-components'

const Button = styled.button`
	border-radius: 5px;
	padding: 8px 16px;
	font-size: 13px;
	font-weight: bold;
	transition: background-color 0.2s ease-out, transform 0.15s ease-in-out;
	border: none;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;

	min-height: 35px;
	height: 35px;
	max-height: 35px;
	min-width: 100px;

	background-color: ${({ backgroundColour }) => backgroundColour || '#7CC142'};
	color: ${({ foreground }) => foreground || '#FFFFFF'};

	&:hover {
		background-color: #6fb435;
	}

	&:focus {
		outline: none;
		box-shadow: 0 0 0 2px rgba(124, 193, 66, 0.5);
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	@media (max-width: 480px) {
		font-size: 12px;
		padding: 8px 12px;
	}
`

export { Button }
